import { useState } from "react"
import useEstadisticHook from '../../api/estadistics'
import useBranchesHook from '../../api/branches'
import { AiOutlineFileSearch, AiOutlineClear } from "react-icons/ai"
import { Message } from '..'
import moment from 'moment'
import { MapContainer, TileLayer } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import HeatmapLayer from '../HeatmapLayer'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
);


const EstadisticOrganization = ({
    organizationBranches,
    organizations,
}) => {
    let isAdmin = false
    let seeAllOrganization = false
    let seeAllBranch = false
    let memberBranch = false
    var { postBranchesByOrganizationUnique } = useBranchesHook({})
    const { postEstadistics } = useEstadisticHook({})

    var { mutateAsync: mutateAsyncbranchesUniqueByOrganization } = postBranchesByOrganizationUnique
    const { isLoading: isLoadingReport, error: errorValidations, mutateAsync: mutateAsyncReport } = postEstadistics


    const [startDate, setStartDate] = useState(moment().subtract(1, 'month').format('YYYY-MM'))
    var [organization, setOrganization] = useState('')
    var [branches, setBranches] = useState([])
    var [branch, setBranch] = useState('')
    var [estadistics, setEstadistics] = useState(null)

    const handleChangeOrganizations = async (organizationId) => {

        var branchlist = []

        if (organizationId != "") {

            setOrganization(organizationId)

            getRoleBranch(organizationId)

            // Si no es member_branch
            if (memberBranch == false) {

                if (isAdmin == true || seeAllOrganization == true) {

                    var existEventOrganizacionBranchList = []
                    existEventOrganizacionBranchList = await mutateAsyncbranchesUniqueByOrganization({ organization_id: organizationId })

                    for (let i = 0; i < existEventOrganizacionBranchList.data.length; i++) {
                        branchlist.push({ _id: existEventOrganizacionBranchList.data[i]._id, name: existEventOrganizacionBranchList.data[i].name })
                    }

                }

                if (seeAllBranch == true) {
                    for (let i = 0; i < organizationBranches.length; i++) {
                        if (organizationBranches[i].organization_id == organizationId) {
                            branchlist.push({ _id: organizationBranches[i]._id, name: organizationBranches[i].name })
                        }
                    }
                }
            } else {

                // Ponemos datos de las sucursales por organizacion
                for (let i = 0; i < organizationBranches.length; i++) {
                    if (organizationBranches[i].organization_id == organizationId) {
                        branchlist.push({ _id: organizationBranches[i]._id, name: organizationBranches[i].name })
                    }
                }
            }

            setBranches(branchlist)
        } else {
            setOrganization('')
            setBranches([])
        }
    }

    // Metodo para agregar las sucursales segun rol
    const handleChangeBranches = async (branchId) => {
        setBranch(branchId)
    }

    // Metodo para obtener el rol por medio de la organizacion
    function getRoleBranch(organizationId) {
        for (let i = 0; i < organizationBranches.length; i++) {
            if (organizationBranches[i].organization_id == organizationId) {

                if (organizationBranches[i].isAdmin) {
                    isAdmin = true
                }

                if (organizationBranches[i].role_type == 'ADMIN_ORGANIZATION' || organizationBranches[i].role_type == 'MONITOR_ORGANIZATION') {
                    seeAllOrganization = true
                }

                if (organizationBranches[i].role_type == 'ADMIN_BRANCH' || organizationBranches[i].role_type == 'MONITOR_BRANCH') {
                    seeAllBranch = true
                }

                if (organizationBranches[i].role_type == 'MEMBER_BRANCH') {
                    memberBranch = true
                }
            }
        }
    }

    // Método para consultar el contenido del reporte
    const generateEstadistics = async () => {

        const estadisticsList = await mutateAsyncReport({
            startDate: startDate,
            organization: organization,
            branch: branch
        })

        console.log(estadisticsList)
        setEstadistics(estadisticsList || null)
    }

    const cleanFormSearch = async () => {
        setOrganization('')
        setBranch('')
        setEstadistics(null)
        setStartDate(moment().subtract(1, 'month').format('YYYY-MM-DD'))
    }

    const chartData = estadistics ? {
        labels: Object.keys(estadistics.eventsHour),
        datasets: [
            {
                label: "Número de alertas",
                data: Object.values(estadistics.eventsHour),
                backgroundColor: "rgba(54, 162, 235, 0.6)",
                borderRadius: 6
            }
        ]
    } : null

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: (context) => `Alertas: ${context.raw}`
                }
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: "Franja horaria (hora Ecuador)"
                }
            },
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: "Cantidad de eventos"
                },
                ticks: {
                    stepSize: 1
                }
            }
        }
    };

    return (

        <div className='table-responsive bg-light p-3 mt-2'>

            {errorValidations && <Message variant='danger'>{errorValidations}</Message>}
            <div className='d-flex  flex-column text-center'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h3 className='fw-light text-muted'>
                            Organización - Estadísticas
                        </h3>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className='col-md-6'>
                    <label htmlFor="organization"><b>Organización:</b></label>
                    <select onChange={(event) => handleChangeOrganizations(event.target.value)}
                        id='organization' name='organization' className='form-control' value={organization}>
                        <option value="" >Seleccione una opción</option>
                        {organizations && organizations.map((organization) => (
                            <option key={organization._id} value={organization._id} >{organization.name}</option>
                        ))}
                    </select>
                </div>
                <div className='col-md-6'>
                    <label htmlFor="branch"><b>Sucursal:</b></label>
                    <select onChange={(event) => handleChangeBranches(event.target.value)} value={branch}
                        id='branch' name='branch' className='form-control' >
                        <option value="" >Seleccione una opción</option>
                        {branches && branches.map((branch) => (
                            <option key={branch._id} value={branch._id} >{branch.name}</option>
                        ))}
                    </select>
                </div>

                <div className='col-md-3'>
                    <label><b>Mes:</b></label>
                    <input
                        type='month'
                        name='startMonth'
                        value={startDate}
                        onChange={(event) => setStartDate(event.target.value)}
                        className='form-control' />
                </div>
            </div>

            <br></br>

            <div className='row'>
                <div className='col-md-4'>
                </div>
                <div className='col-md-4 text-center'>

                    <button type="button" onClick={generateEstadistics} className="btn btn-primary">
                        {isLoadingReport ?
                            (<span className='spinner-border spinner-border-sm' />) :
                            ('')}
                        &nbsp; <AiOutlineFileSearch /> Generar</button>&nbsp;&nbsp;


                    <button type="button" onClick={cleanFormSearch} className="btn btn-primary">

                        &nbsp; <AiOutlineClear />Limpiar</button>
                </div>
                <div className='col-md-4'>
                </div>
            </div>

            {estadistics && (
                <>
                    <div className="row g-3 mb-4">

                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="card shadow-sm border-0 h-100">
                                <div className="card-body text-center">
                                    <h6 className="text-muted">Alertas totales</h6>
                                    <h3 className="fw-bold mb-0">{estadistics.total}</h3>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="card shadow-sm border-0 h-100">
                                <div className="card-body text-center">
                                    <h6 className="text-muted">Alertas atendidas</h6>
                                    <h3 className="fw-bold mb-0">{estadistics.atendidas}</h3>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="card shadow-sm border-0 h-100">
                                <div className="card-body text-center">
                                    <h6 className="text-muted">Tiempo medio</h6>
                                    <h5 className="fw-bold mb-0">
                                        {estadistics.med.hours}h {estadistics.med.minutes}m {estadistics.med.seconds}s
                                    </h5>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="card shadow-sm border-0 h-100">
                                <div className="card-body text-center">
                                    <h6 className="text-muted">Tiempo máximo</h6>
                                    <h5 className="fw-bold mb-0">
                                        {estadistics.max.hours}h {estadistics.max.minutes}m {estadistics.max.seconds}s
                                    </h5>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="row g-3 mb-4">
                        <div className="col-12 col-lg-3">
                            <div className="card shadow-sm border-0 h-100">
                                <div className="card-body text-center">
                                    <h6 className="text-muted">Tiempo mínimo</h6>
                                    <h5 className="fw-bold mb-0">
                                        {estadistics.min.hours}h {estadistics.min.minutes}m {estadistics.min.seconds}s
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-12">
                            <div className="card shadow-sm border-0">
                                <div className="card-body">
                                    <h6 className="text-muted mb-3">Alertas por franja horaria</h6>
                                    <div style={{ height: "320px" }}>
                                        <Bar data={chartData} options={chartOptions} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card shadow-sm border-0">
                                <div className="card-body">
                                    <h6 className="text-muted mb-3">Mapa de calor de alertas</h6>
                                    <div style={{ height: "500px" }}>
                                        <MapContainer
                                            key={estadistics.centerMap.location.coordinates.join(",")}
                                            center={estadistics.centerMap.location.coordinates}
                                            zoom={13}
                                            style={{ height: "100%", width: "100%" }}
                                        >
                                            <TileLayer
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            />
                                            <HeatmapLayer
                                                points={estadistics.heatPoints}
                                                latitudeExtractor={p => p.lat}
                                                longitudeExtractor={p => p.lng}
                                                intensityExtractor={p => p.weight}
                                            />
                                        </MapContainer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export default EstadisticOrganization

